import { useState, useMemo, useEffect } from 'react';
import { find, get } from 'lodash/fp';
import {
  DetailsObjectType,
  EpisodeType,
  ChannelType,
  PlaybackType,
} from 'store/pages/loaders/loader-types';
import requester from 'utils/requester';
import api from 'config/api';

const findStreamResource = find(
  ({ type, state, category }) =>
    ['hls', 'hls-live'].includes(type) && state === 'deployed' && category !== 'trailer',
);

const useLoadResource = (object: DetailsObjectType | EpisodeType | ChannelType | null) => {
  const [resource, setResource] = useState<PlaybackType>(null);
  const [error, setError] = useState<string>(null);

  const result = useMemo(() => ({ resource, error }), [resource, error]);

  const assetId = object?.id;

  useEffect(() => {
    if (!assetId) return;

    const streamResource = findStreamResource(object.resources) as typeof object.resources[0];

    const loadData = async () => {
      try {
        const response = await requester({
          method: 'post',
          url: `${api.host}${api.endpoints.assets}/${assetId}/resources/${streamResource.id}/playback-sessions`,
        });
        setResource(response.data);
      } catch (error) {
        const message = get(['response', 'data', 'error', 'message'])(error) || error.message;
        console.error({ message });
        setError(message);
      }
    };

    loadData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetId]);

  return result;
};

export default useLoadResource;
